<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div>
      <div v-if="!ifEmployee">
        <div  v-if="selfOccupiedPropertyBlock">
          <div class="mb-3">
          <span> <strong>House Rent Allowance</strong></span>
          <span class="text-right-side"> <strong>0/2,50,000</strong></span>
          </div>
          <div class="add-self-occupied-property" @click="addSelfOccupiedProperty">
            <div class="center-block-add-new">
              <img class="block-add-new-icon" src="@/assets/circle-cross.svg" alt />
              <span class="add-new">Add Self Occupied Property</span>
            </div>
          </div>
          <hr>
          <div class="my-4">
          <span> <strong>Others (₹)</strong></span>
          <span class="text-right-side"> <strong>0/40,000</strong></span>
          </div>
          <!-- Table -->
          <div class="datatable-outer-container">
              <data-table
                            :columns="exemptTableColumns"
                            :tableData="Exemption10.others"
                            :showinrow="true"
                            :withForm="false"
                            :showhistory="false"
                            :showdelete="false"
                            :showedit="false"
                          
                          >
                            <template v-slot:rowcontent="slotprops">
                              <div>
                                <p
                                  v-if="slotprops.value.column.key == 'slno'"
                                >{{slotprops.value.index+1}}</p>
                                <p
                                  v-if="slotprops.value.column.key == 'particulars'"
                                >{{
                                    slotprops.value.record['InvestmentComponentType.name'] ?
                                      slotprops.value.record['InvestmentComponentType.name'] : slotprops.value.record.name
                                  }}</p>
                                <!-- <p
                                  v-if="slotprops.value.column.key == 'limits'"
                                >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount : (slotprops.value.record.rule && Object.keys(slotprops.value.record.rule).length ?slotprops.value.record.rule.maximum_limit:null)}}</p> -->
                                <p v-if="slotprops.value.column.key=='planned'">
                                  <txt
                                    type="number"
                                    :disable="false"
                                    :name="'explannedvalue'+slotprops.value.index"
                                    v-model="Exemption10.others[slotprops.value.index].planned"
                                    v-validate="{required: true, regex:/^[1-9]{1}[0-9]{6}$/}"
                                  />
                                  <!-- <span v-else>-</span> -->
                                </p>
                                
                              </div>
                            </template>
                          </data-table>
          </div>
          <!-- End -->
        </div>
      </div>
      <div v-else>
        <!-- <div v-if="ifEmployee">
            <template >
              <div class="d-payroll__accord">
                <div class="it-payroll__accordBlock" :class="{active: isActiveHRA}">
                  <div
                    class="it_accordHeading d-heading"
                    @click="isActiveHRA = !isActiveHRA"
                  >House Rent Allowance</div>
                  <div class="accordContent"> -->
                    <!-- <div class="row margin-t-m" v-for="(house,index) in Exemption10.HRA" :key="index"> -->
                      <!-- <div class="col-6">
                        <div class="d-heading2">House {{index+1}}</div>
                      </div> -->
                      <!-- <div class="col-6" v-if="Exemption10.HRA.length > 1">
                        <a class="delete-btn" @click="deleteHouse(index)">
                          <img src="@/assets/delete.svg" />
                          <span>Delete House</span>
                        </a>
                      </div>
                      <div class="col-12 margin-t-s">
                        <div class="icon">
                          <div class="d-heading2">Owner’s Details</div>
                          <div class="row">
                            <div class="col-4">
                              <txt
                                label="Name"
                                :name="'ownername'+index"
                                placeholder="Name"
                                v-model="house.ownerDetails.name"
                              />
                            </div>
                            <div class="col-4">
                              <txt
                                label="PAN number"
                                :name="'ownerpan'+index"
                                placeholder="BMQPR8328R"
                                v-model="house.ownerDetails.pan_number"
                              />
                            </div> -->
                            <!-- <div class="col-4">
                              <span class="input-label">PAN Card</span>
                              <div class="attach_file">
                                <label class="fileLabel" :for="'pfile'+index">
                                  <img src="@/assets/ic-attachment.png" alt />
                                  <input
                                    type="file"
                                    :id="'pfile'+index"
                                    @change="uploadPanCard($event.target.files[0], index, 'owner')"
                                  />
                                </label>
                              </div>
                              <a
                                :href="house.ownerDetails.pancardUrl"
                                target="_blank"
                              >{{house.ownerDetails.fileName}}</a>
                            </div> -->
                            <!-- <div class="col-4">
                              <txt
                                label="Pincode"
                                :name="'ownerpincode'+index"
                                placeholder="pincode"
                                v-model="house.ownerDetails.pincode"
                              />
                            </div>
                          </div>
                          <div class="row margin-t-s">
                            <div class="col-4">
                              <txt
                                label="Address"
                                :name="'owneraddress'+index"
                                placeholder="address"
                                v-model="house.ownerDetails.address"
                              />
                            </div> -->
                            <!-- <div class="col-4">
                              <tl-select
                                label="State / Union Territory"
                                :name="'ownerstate'+index"
                                labelText="state_name"
                                :options="stateList"
                                v-model="house.ownerDetails.state"
                                @change="(val)=> house.ownerDetails.state = val"
                              ></tl-select>
                            </div> -->
                          <!-- </div> -->

                          <!--<div class="row margin-t-m">
                            <div class="col-12 margin-b-m">
                              <tl-checkbox
                                label="Co- Owner details"
                                :name="'co_owner'+index"
                                v-model="house.ownerDetails.isCoOwner"
                              />
                            </div>
                            <div class="col-4">
                              <txt
                                label="Name"
                                :name="'coownername'+index"
                                placeholder="Name"
                                v-model="house.ownerDetails.cownerDetails.name"
                              />
                            </div>
                            <div class="col-4">
                              <txt
                                label="PAN number"
                                :name="'cownerpan'+index"
                                placeholder="BMQPR8328R"
                                v-model="house.ownerDetails.cownerDetails.pan_number"
                              />
                            </div>
                             <div class="col-4">
                              <span class="input-label">PAN Card</span>
                              <div class="attach_file">
                                <label class="fileLabel" :for="'coownerfile'+index">
                                  <img src="@/assets/ic-attachment.png" alt />
                                  <input
                                    type="file"
                                    :id="'coownerfile'+index"
                                    @change="uploadPanCard($event.target.files[0], index, 'co-owner')"
                                  />
                                </label>
                              </div>
                              <a
                                :href="house.ownerDetails.cownerDetails.pancardUrl"
                                target="_blank"
                              >{{house.ownerDetails.cownerDetails.fileName}}</a>
                            </div> 
                            <div class="col-4">
                              <txt
                                label="Pincode"
                                :name="'coownerpincode'+index"
                                placeholder="pincode"
                                v-model="house.ownerDetails.cownerDetails.pincode"
                              />
                            </div>
                          </div> -->
                          <!--<div class="row margin-t-s">
                            <div class="col-4">
                              <txt
                                label="Address"
                                :name="'coowneraddress'+index"
                                placeholder="address"
                                v-model="house.ownerDetails.cownerDetails.address"
                              />
                            </div>
                             <div class="col-4">
                              <tl-select
                                label="State / Union Territory"
                                labelText="state_name"
                                :name="'coownerstate'+index"
                                :options="stateList"
                                v-model="house.ownerDetails.cownerDetails.state"
                                @change="(val) => house.ownerDetails.cownerDetails.state = val"
                              ></tl-select>
                            </div> 
                          </div> -->
                           <!-- <div class="row margin-t-m" v-for="(item,idx) in house.rentList" :key="idx">
                            <div class="col-3">
                              <div class="label">
                                <span class="input-label">Rent from</span>
                                <date-picker
                                  :value="item.rentFrom"
                                  @datevalue="(val)=>item.rentFrom=val"
                                  :name="'rentFrom'+index+idx"
                                />
                              </div>
                            </div>
                            <div class="col-2">
                              <div class="label">
                                <span class="input-label">Rent to</span>
                                <date-picker
                                  :value="item.rentTo"
                                  @datevalue="(val)=>item.rentTo=val"
                                  :name="'rentTo'+index+idx"
                                />
                              </div> -->
                            <!-- </div>
                            <div class="col-2">
                              <txt
                                label="Amount"
                                type="number"
                                :name="'rentamount'+index+idx"
                                placeholder="amount"
                                v-model="item.amount"
                              />
                            </div> -->
                            <!-- <div class="col-3">
                              <span class="input-label">Rent Agreement</span>
                              <div class="attach_file">
                                <label class="fileLabel" :for="'agreementfile'+index+idx">
                                  <img src="@/assets/ic-attachment.png" alt />
                                  <input
                                    type="file"
                                    :id="'agreementfile'+index+idx"
                                    @change="uploadRentAggr($event.target.files[0], index, idx)"
                                  />
                                </label>
                              </div>
                              <a :href="item.agreementDoc" target="_blank">{{item.fileName}}</a>
                            </div> -->
                            <!-- <div class="col-2" v-if="house.rentList.length > 1">
                              <a class="delete-btn" @click="deleteDate(index, idx)">
                                <img src="@/assets/delete.svg" />
                                <span>Delete House</span>
                              </a>
                            </div>
                          </div> 
                          <div class="row margin-t-m margin-b-l">
                            <div class="col-12">
                              <div class="row-container align-center">
                                <img src="@/assets/group-5.svg" class="Group-5" />
                                <button class="text-green" @click="addMoreDate(index)">Add New Date</button>
                              </div>
                            </div>
                          </div>  -->
                         <!-- <div class="row margin-t-m">
                            <div class="col-4">
                              <txt
                                label="Pin code"
                                :name="'pincode'+index"
                                placeholder="pincode"
                                v-model="house.pincode"
                              />
                            </div>
                            <div class="col-4">
                              <span class="inline-flex margin-t-m">
                                <tl-radio
                                  label="Metro"
                                  :id="'metro'+index"
                                  value="metro"
                                  :name="'cityType'+index"
                                  v-model="house.cityType"
                                ></tl-radio>
                                <tl-radio
                                  label="Non-Metro"
                                  :id="'non_metro'+index"
                                  value="non_metro"
                                  :name="'cityType'+index"
                                  v-model="house.cityType"
                                ></tl-radio>
                              </span>
                            </div>
                          </div> 
                          <div class="row margin-t-s">
                            <div class="col-4">
                              <txt
                                label="Address"
                                :name="'address'+index"
                                placeholder="address"
                                v-model="house.address"
                              />
                            </div>
                            <div class="col-4">
                              <tl-select
                                label="State / Union Territory"
                                labelText="state_name"
                                :name="'state'+index"
                                :options="stateList"
                                v-model="house.State"
                                @change="(val) => house.State = val"
                              ></tl-select>
                            </div>
                          </div> -->
                        <!-- </div>
                      </div>
                    </div> -->
                    <!-- <div class="row margin-t-m margin-b-l">
                      <div class="col-12">
                        <div class="row-container align-center">
                          <img src="@/assets/group-5.svg" class="Group-5" />
                          <button class="text-green" @click="addMoreHouse">Add More House</button>
                        </div>
                      </div>
                    </div> -->
                  <!-- </div>
                </div>
              </div> -->
              <!-- others -->

              <!-- <div class="d-payroll__accord">
                <div class="it-payroll__accordBlock" :class="{active: isActiveOthers}">
                  <div
                    class="it_accordHeading d-heading"
                    @click="isActiveOthers = !isActiveOthers"
                  >Others</div>
                  <div class="accordContent">
                    <div class="row">
                      <div class="col-12">
                        <div class="icon">
                          <data-table
                            :columns="exemptTableColumns"
                            :tableData="Exemption10.others"
                            :showinrow="true"
                            :withForm="false"
                            :showhistory="false"
                            :showdelete="false"
                            @editStart="editRow($event)"
                          >
                            <template v-slot:rowcontent="slotprops">
                              <div>
                                <p
                                  v-if="slotprops.value.column.key == 'slno'"
                                >{{slotprops.value.index+1}}</p>
                                <p
                                  v-if="slotprops.value.column.key == 'particulars'"
                                >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.name: slotprops.value.record.name}}</p>
                                <p
                                  v-if="slotprops.value.column.key == 'limits'"
                                >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount : (Object.keys(slotprops.value.record.rule).length ?slotprops.value.record.rule.maximum_limit:null)}}</p>
                                <p v-if="slotprops.value.column.key=='planned'">
                                  <txt
                                    type="number"
                                    :disable="true"
                                    :name="'explannedvalue'+slotprops.value.index"
                                    v-model="Exemption10.others[slotprops.value.index].planned"
                                  />
                                </p>
                                <p v-if="slotprops.value.column.key=='actual'">
                                  <txt
                                    v-if="slotprops.value.record[slotprops.value.column.key] != null"
                                    type="number"
                                    :disable="true"
                                    :name="'exactualvalue'+slotprops.value.index"
                                    v-model="Exemption10.others[slotprops.value.index].actual"
                                  />
                                  <span v-else>-</span>
                                </p>
                                <p v-if="slotprops.value.column.key=='proofs'">
                                  <a
                                    href="javascript:void(0)"
                                    v-if="slotprops.value.record['file_location']"
                                    @click="openDocModal(Exemption10.others[slotprops.value.index].file_location, 'Section10')"
                                  >{{slotprops.value.record['file_location'].length }} attachment</a>
                                  <span v-else>-</span>
                                </p>
                              </div>
                            </template>
                          </data-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            <!-- </template> -->
        <!-- </div> -->
      </div>

      <!-- Non-employee user part show below like (Super Admin, Admin, Teamleader, Auditor) -->
        <!-- <div v-if="selfOccupiedProperty">
            <template >
              <div class="d-payroll__accord">
                <div class="it-payroll__accordBlock" :class="{active: isActiveHRA}">
                  <div
                    class="it_accordHeading d-heading"
                    @click="isActiveHRA = !isActiveHRA"
                  >House Rent Allowance</div>
                  <div class="accordContent">
                    <div class="row margin-t-m" v-for="(house,index) in Exemption10.HRA" :key="index">
                      <div class="col-6">
                        <div class="d-heading2">House {{index+1}}</div>
                      </div>
                      <div class="col-6" v-if="Exemption10.HRA.length > 1">
                        <a class="delete-btn" @click="deleteHouse(index)">
                          <img src="@/assets/delete.svg" />
                          <span>Delete House</span>
                        </a>
                      </div>
                      <div class="col-12 margin-t-s">
                        <div class="icon">
                          <div class="d-heading2">Owner’s Details</div>
                          <div class="row">
                            <div class="col-4">
                              <txt
                                label="Name"
                                :name="'ownername'+index"
                                placeholder="Name"
                                v-model="house.ownerDetails.name"
                              />
                            </div>
                            <div class="col-4">
                              <txt
                                label="PAN number"
                                :name="'ownerpan'+index"
                                placeholder="BMQPR8328R"
                                v-model="house.ownerDetails.pan_number"
                              />
                            </div>
                            <div class="col-4">
                              <span class="input-label">PAN Card</span>
                              <div class="attach_file">
                                <label class="fileLabel" :for="'pfile'+index">
                                  <img src="@/assets/ic-attachment.png" alt />
                                  <input
                                    type="file"
                                    :id="'pfile'+index"
                                    @change="uploadPanCard($event.target.files[0], index, 'owner')"
                                  />
                                </label>
                              </div>
                              <a
                                :href="house.ownerDetails.pancardUrl"
                                target="_blank"
                              >{{house.ownerDetails.fileName}}</a>
                            </div>
                            <div class="col-4">
                              <txt
                                label="Pincode"
                                :name="'ownerpincode'+index"
                                placeholder="pincode"
                                v-model="house.ownerDetails.pincode"
                              />
                            </div>
                          </div>
                          <div class="row margin-t-s">
                            <div class="col-4">
                              <txt
                                label="Address"
                                :name="'owneraddress'+index"
                                placeholder="address"
                                v-model="house.ownerDetails.address"
                              />
                            </div>
                            <div class="col-4">
                              <tl-select
                                label="State / Union Territory"
                                :name="'ownerstate'+index"
                                labelText="state_name"
                                :options="stateList"
                                v-model="house.ownerDetails.state"
                                @change="(val)=> house.ownerDetails.state = val"
                              ></tl-select>
                            </div>
                          </div>

                          <div class="row margin-t-m">
                            <div class="col-12 margin-b-m">
                              <tl-checkbox
                                label="Co- Owner details"
                                :name="'co_owner'+index"
                                v-model="house.ownerDetails.isCoOwner"
                              />
                            </div>
                            <div class="col-4">
                              <txt
                                label="Name"
                                :name="'coownername'+index"
                                placeholder="Name"
                                v-model="house.ownerDetails.cownerDetails.name"
                              />
                            </div>
                            <div class="col-4">
                              <txt
                                label="PAN number"
                                :name="'cownerpan'+index"
                                placeholder="BMQPR8328R"
                                v-model="house.ownerDetails.cownerDetails.pan_number"
                              />
                            </div>
                             <div class="col-4">
                              <span class="input-label">PAN Card</span>
                              <div class="attach_file">
                                <label class="fileLabel" :for="'coownerfile'+index">
                                  <img src="@/assets/ic-attachment.png" alt />
                                  <input
                                    type="file"
                                    :id="'coownerfile'+index"
                                    @change="uploadPanCard($event.target.files[0], index, 'co-owner')"
                                  />
                                </label>
                              </div>
                              <a
                                :href="house.ownerDetails.cownerDetails.pancardUrl"
                                target="_blank"
                              >{{house.ownerDetails.cownerDetails.fileName}}</a>
                            </div> 
                            <div class="col-4">
                              <txt
                                label="Pincode"
                                :name="'coownerpincode'+index"
                                placeholder="pincode"
                                v-model="house.ownerDetails.cownerDetails.pincode"
                              />
                            </div>
                          </div>
                          <div class="row margin-t-s">
                            <div class="col-4">
                              <txt
                                label="Address"
                                :name="'coowneraddress'+index"
                                placeholder="address"
                                v-model="house.ownerDetails.cownerDetails.address"
                              />
                            </div>
                             <div class="col-4">
                              <tl-select
                                label="State / Union Territory"
                                labelText="state_name"
                                :name="'coownerstate'+index"
                                :options="stateList"
                                v-model="house.ownerDetails.cownerDetails.state"
                                @change="(val) => house.ownerDetails.cownerDetails.state = val"
                              ></tl-select>
                            </div> 
                          </div>
                           <div class="row margin-t-m" v-for="(item,idx) in house.rentList" :key="idx">
                            <div class="col-3">
                              <div class="label">
                                <span class="input-label">Rent from</span>
                                <date-picker
                                  :value="item.rentFrom"
                                  @datevalue="(val)=>item.rentFrom=val"
                                  :name="'rentFrom'+index+idx"
                                />
                              </div>
                            </div>
                            <div class="col-2">
                              <div class="label">
                                <span class="input-label">Rent to</span>
                                <date-picker
                                  :value="item.rentTo"
                                  @datevalue="(val)=>item.rentTo=val"
                                  :name="'rentTo'+index+idx"
                                />
                              </div>
                            </div>
                            <div class="col-2">
                              <txt
                                label="Amount"
                                type="number"
                                :name="'rentamount'+index+idx"
                                placeholder="amount"
                                v-model="item.amount"
                              />
                            </div>
                            <div class="col-3">
                              <span class="input-label">Rent Agreement</span>
                              <div class="attach_file">
                                <label class="fileLabel" :for="'agreementfile'+index+idx">
                                  <img src="@/assets/ic-attachment.png" alt />
                                  <input
                                    type="file"
                                    :id="'agreementfile'+index+idx"
                                    @change="uploadRentAggr($event.target.files[0], index, idx)"
                                  />
                                </label>
                              </div>
                              <a :href="item.agreementDoc" target="_blank">{{item.fileName}}</a>
                            </div>
                            <div class="col-2" v-if="house.rentList.length > 1">
                              <a class="delete-btn" @click="deleteDate(index, idx)">
                                <img src="@/assets/delete.svg" />
                                <span>Delete House</span>
                              </a>
                            </div>
                          </div> 
                          <div class="row margin-t-m margin-b-l">
                            <div class="col-12">
                              <div class="row-container align-center">
                                <img src="@/assets/group-5.svg" class="Group-5" />
                                <button class="text-green" @click="addMoreDate(index)">Add New Date</button>
                              </div>
                            </div>
                          </div> 
                         <div class="row margin-t-m">
                            <div class="col-4">
                              <txt
                                label="Pin code"
                                :name="'pincode'+index"
                                placeholder="pincode"
                                v-model="house.pincode"
                              />
                            </div>
                            <div class="col-4">
                              <span class="inline-flex margin-t-m">
                                <tl-radio
                                  label="Metro"
                                  :id="'metro'+index"
                                  value="metro"
                                  :name="'cityType'+index"
                                  v-model="house.cityType"
                                ></tl-radio>
                                <tl-radio
                                  label="Non-Metro"
                                  :id="'non_metro'+index"
                                  value="non_metro"
                                  :name="'cityType'+index"
                                  v-model="house.cityType"
                                ></tl-radio>
                              </span>
                            </div>
                          </div> 
                          <div class="row margin-t-s">
                            <div class="col-4">
                              <txt
                                label="Address"
                                :name="'address'+index"
                                placeholder="address"
                                v-model="house.address"
                              />
                            </div>
                            <div class="col-4">
                              <tl-select
                                label="State / Union Territory"
                                labelText="state_name"
                                :name="'state'+index"
                                :options="stateList"
                                v-model="house.State"
                                @change="(val) => house.State = val"
                              ></tl-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row margin-t-m margin-b-l">
                      <div class="col-12">
                        <div class="row-container align-center">
                          <img src="@/assets/group-5.svg" class="Group-5" />
                          <button class="text-green" @click="addMoreHouse">Add More House</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- others -->

              <!-- <div class="d-payroll__accord">
                <div class="it-payroll__accordBlock" :class="{active: isActiveOthers}">
                  <div
                    class="it_accordHeading d-heading"
                    @click="isActiveOthers = !isActiveOthers"
                  >Others</div>
                  <div class="accordContent">
                    <div class="row">
                      <div class="col-12">
                        <div class="icon">
                          <data-table
                            :columns="exemptTableColumns"
                            :tableData="Exemption10.others"
                            :showinrow="true"
                            :withForm="false"
                            :showhistory="false"
                            :showdelete="false"
                            @editStart="editRow($event)"
                          >
                            <template v-slot:rowcontent="slotprops">
                              <div>
                                <p
                                  v-if="slotprops.value.column.key == 'slno'"
                                >{{slotprops.value.index+1}}</p>
                                <p
                                  v-if="slotprops.value.column.key == 'particulars'"
                                >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.name: slotprops.value.record.name}}</p>
                                <p
                                  v-if="slotprops.value.column.key == 'limits'"
                                >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount : (Object.keys(slotprops.value.record.rule).length ?slotprops.value.record.rule.maximum_limit:null)}}</p>
                                <p v-if="slotprops.value.column.key=='planned'">
                                  <txt
                                    type="number"
                                    :disable="true"
                                    :name="'explannedvalue'+slotprops.value.index"
                                    v-model="Exemption10.others[slotprops.value.index].planned"
                                  />
                                </p>
                                <p v-if="slotprops.value.column.key=='actual'">
                                  <txt
                                    v-if="slotprops.value.record[slotprops.value.column.key] != null"
                                    type="number"
                                    :disable="true"
                                    :name="'exactualvalue'+slotprops.value.index"
                                    v-model="Exemption10.others[slotprops.value.index].actual"
                                  />
                                  <span v-else>-</span>
                                </p>
                                <p v-if="slotprops.value.column.key=='proofs'">
                                  <a
                                    href="javascript:void(0)"
                                    v-if="slotprops.value.record['file_location']"
                                    @click="openDocModal(Exemption10.others[slotprops.value.index].file_location, 'Section10')"
                                  >{{slotprops.value.record['file_location'].length }} attachment</a>
                                  <span v-else>-</span>
                                </p>
                              </div>
                            </template>
                          </data-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            <!-- </template>
        </div> -->
        <div v-if="selfOccupiedProperty">
          <div  style="display: flex; justify-content: space-between; width: 100%;">
          <div class="heading-text">Rent Paid Details for HRA Exemption</div>
          <div class=" align-center" style="display: flex; align-items: center; gap: 5px;">
            <img src="@/assets/group-5.svg" class="Group-5" />
            <button class="text-green" @click="addMoreDate()">Add New Date</button>
        </div>
        </div>
        <div class="row form-group my-3 hraMain" v-for="(item, index) in Exemption10.HRA.planned.details" :key="index">
          <div class="col-4 pl-0">
            <div class="label">
              <span class="input-label">From Date</span>
              <date-picker
                name="fromDate"
                data-vv-as="from date"
                @datevalue="(val) => (item.from = val)"
                :value="item.from"
                v-validate="{ required: true }"
                :classname="errors.has('fromDate')"
                :errormsg="errors.first('fromDate')"
                :dates-disabled="{ to: new Date(employeeData.date_of_joining) }"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="label">
              <span class="input-label">To Date</span>
              <date-picker
                name="toDate"
                data-vv-as="to date"
                @datevalue="(val) => (item.to = val)"
                :value="item.to"
                v-validate="{ required: true }"
                :classname="errors.has('toDate')"
                :errormsg="errors.first('toDate')"
                :dates-disabled="{ to: new Date(item.from) }"
              />
            </div>
          </div>
          <div class="col-4">
            <txt
              label="Amount"
              type="text"
              v-model="item.value"
              name="Amount"
              v-validate="'required'"
              :classname="errors.has('Amount')"
              :errormsg="errors.first('Amount')"
            />
          </div>
          <div class="col-4 pl-0 metroBtn" style="margin: 4px 0;">
          <tl-select
            label="Metro"
            :options="metro_city_options"
            @change="(val) => { setMetro(val, item), item.ownerDetails.metro = val }"
            v-model="item.ownerDetails.metro"
          ></tl-select>
            <!-- <p class="text-metro">Metro</p>
            <div class="radio-grp">
              <tl-radio
                class="radio-grp-btn"
                :name="'mumbai' + index"
                label="Mumbai"
                :id="'mumbai' + index"
                value="mumbai"
                v-model="item.ownerDetails.metro"
                @change="(val) => { setMetro(val, item), item.ownerDetails.metro = val }"
              />
              <tl-radio
                class="radio-grp-btn"
                :name="'chennai' + index"
                label="Chennai"
                :id="'chennai' + index"
                value="chennai"
                v-model="item.ownerDetails.metro"
                @change="(val) => { setMetro(val, item), item.ownerDetails.metro = val }"
              />
              <tl-radio
                class="radio-grp-btn"
                :name="'kolkata' + index"
                label="Kolkata"
                :id="'kolkata' + index"
                value="kolkata"
                v-model="item.ownerDetails.metro"
                @change="(val) => { setMetro(val, item), item.ownerDetails.metro = val }"
              />
              <tl-radio
                class="radio-grp-btn"
                :name="'delhi' + index"
                label="Delhi"
                :id="'delhi' + index"
                value="delhi"
                v-model="item.ownerDetails.metro"
                @change="(val) => { setMetro(val, item), item.ownerDetails.metro = val }"
              />
              <tl-radio
                class="radio-grp-btn"
                :name="'other' + index"
                label="Other"
                :id="'other' + index"
                value="non_metro"
                v-model="item.ownerDetails.metro"
                @change="(val) => { setMetro(val, item), item.ownerDetails.metro = val }"
              />
            </div> -->
            <!-- <tl-select
          label="Metro"
          :options="['Yes', 'No']"
          v-model="hraFormData.isMetro"
          @change="(val) => (hraFormData.isMetro = val)"
        ></tl-select> -->
          </div>
          <div class="col-4 metroBtn">
            <txt
              label="Owner PAN Number"
              type="text"
              v-model="item.ownerDetails.panNumber"
              :name="`${index}owner PAN Number`"
              v-validate="{ required: item.value > 8000 ? true : false, regex: pancardRegex }"
              :classname="errors.has(`${index}owner PAN Number`)"
              errormsg="Owner PAN number is required & should be in valid format"
            />
          </div>
          <div class="col-4 metroBtn" v-if="Exemption10.HRA.planned.details.length > 1">
              <a class="delete-btn" @click="deleteHouse(index)">
              <img src="@/assets/delete.svg" />
              <span>Delete House</span>
              </a>
          </div>
        </div>
        <!-- <div class="row form-group my-3">
      <div class="col-4 pl-0">
        <txt
          label="City"
          type="text"
          v-model="hraFormData.city"
          name="City"
          v-validate="'required'"
          :classname="errors.has('City')"
          :errormsg="errors.first('City')"
        />
      </div>
      <div class="col-4">
        <txt
          label="State"
          type="text"
          v-model="hraFormData.state"
          name="State"
          v-validate="'required'"
          :classname="errors.has('State')"
          :errormsg="errors.first('State')"
        />
      </div>
      <div class="col-4">
        <tl-select
          label="Metro"
          :options="['Yes', 'No']"
          v-model="hraFormData.isMetro"
          @change="(val) => (hraFormData.isMetro = val)"
        ></tl-select>
      </div>
    </div> -->
        <!-- <div class="row form-group my-3">
      <div class="col-4 pl-0">
        <txt
          label="Exemption Amount"
          type="text"
          v-model="hraFormData.exemption_amount"
          name="Exemption Amount"
          v-validate="'required'"
          :classname="errors.has('Exemption Amount')"
          :errormsg="errors.first('Exemption Amount')"
        />
      </div>
    </div> -->
        <br />
        <!-- <div class="heading-text">{{ calculateText }}</div> -->
        <!-- Table -->
        <!-- <div class="datatable-outer-container my-3">
      <div class="datatable-main">
        <table class="datatable">
          <thead>
            <tr class="header-row">
              <th>Details</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tr class="record-row">
            <td class="row-item">
              <strong>Actual HRA Received</strong>
            </td>
            <td class="row-item">
              {{ hraFormData.actualHraReceived }}
            </td>
          </tr>
          <tr class="record-row">
            <td class="row-item">
              <strong>Rent Paid minus 10% of Salary (Basic + DA)</strong>
            </td>
            <td class="row-item">
              {{ hraFormData.rentPaidBasicDa }}
            </td>
          </tr>
          <tr class="record-row">
            <td class="row-item">
              <strong>40% or 50% of Salary (Basic+DA)</strong>
            </td>
            <td class="row-item">
              {{ hraFormData.percentSalBasicDa }}
            </td>
          </tr>
          <tr class="record-row">
            <td class="row-item">
              <strong>Least of the above is exempted</strong>
            </td>
            <td class="row-item">
              {{ hraFormData.leastExempted }}
            </td>
          </tr>
        </table>
      </div>
    </div> -->
        <!-- End -->
      </div>
      <!-- End here -->

      <!-- <pop-up-message
        v-if="showSuccessMsg"
        :message="`Components successfully added`"
        btnText="Back To Assign Fixed Non CTC Components "
        @back="close"
      ></pop-up-message> -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Cancel" type="secondary" @click="goBack"/>
              <btn text="Save" type="primary" @click="submitData"/>
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  get_axios_file_instance,
  api_variables,
} from "@/apis/variables.js"; 
import * as globalConfig from "@/apis/config.js";
var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);
export default {
  name: "exemptionUnderSectionDeduction",
  props: {
    section10:{
      type:Object
    }
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      date_of_joining: '',
      showSuccessMsg: false,
      selfOccupiedPropertyBlock: true,
      selfOccupiedProperty: false,
      stateList: [],
      pancardRegex: null,
      metro_city_options: ["Delhi", "Mumbai", "Kolkata", "Chennai", "Bengaluru", "Hyderabad", "Ahmedabad", "Pune", "Other"],
      Exemption10: {
        HRA: {
          actual: {
            status: false,
            details: []
          },
          planned: {
            status: true,
            details: [
            {
                to: "",
                from: "",
                metro: "",
                value: 0,
                ownerDetails: {
                  name: "",
                  state: "",
                  toDate: "",
                  address: "",
                  pinCode: null,
                  fileName: "",
                  fromDate: "",
                  metro: "",
                  panNumber: "",
                  pancardUrl: ""
                },
                cownerDetails: {
                  name: "",
                  state: "",
                  address: "",
                  pincode:  null,
                  fileName: "",
                  panNumber: "",
                  pancardUrl: ""
                }
              }
            ]
          },
          approved: {
            status: false,
            details: [ ]
          }
        },
        others: []
      },
       exemptTableColumns: [
        {
          label: "SL No.",
          key: "slno"
        },
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Yearly limits",
          key: "limits"
        },
        {
          label: "Planned",
          key: "planned"
        }
      ],
      isActiveHRA: true,
      isActiveOthers: true,
    };
  },
  computed: {
   ...mapState({
     // incomeTaxData: state => state.onboard.statutoryinfo.incometax.data,
      globalData: state => state.globalapi.globalData.data
    }),
   
   
   le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },

    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
    },

      },

  mounted() {
    this.showSuccessMsg = false;
    this.getProfileData();
    this.load();
    this.pancardRegex = globalConfig.Regex.EMPLOYEE_PAN;
    
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
    this.pancardRegex = globalConfig.Regex.EMPLOYEE_PAN;
  },

  methods: {
    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll'
    }),
    setGolbalData() {
      try {
       
        this.stateList = this.globalData
          ? this.globalData.State
            ? this.globalData.State
            : []
          : [];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addSelfOccupiedProperty() {
      this.selfOccupiedPropertyBlock = false;
      this.selfOccupiedProperty = true;
      this.$emit("passPopupHeader");
    },

      load(){
        this.setGolbalData();
        //console.log("data check...............",this.section10);
        let data = this.section10;
         this.Exemption10.others = [];
          data.others.forEach(element => {
            this.Exemption10.others.push({
              planned: element.planned ? element.planned : 0,
             
              ...element
            });
          });
          if (data.HRA.planned.details.length > 0) {
            this.Exemption10.HRA = data.HRA;
          }
          //console.log("inside the section 10",data);
      },
      addMoreHouse() {
      try {
        this.Exemption10.HRA.push({
          address: "",
          pincode: "",
          State: "",
          cityType: "metro",
          rentList: [
            {
              rentFrom: "",
              rentTo: "",
              amount: "",
              agreementDoc: ""
            }
          ],
          ownerDetails: {
            name: "",
            pan_number: "",
            pincode: "",
            address: "",
            state: "",
            pancardUrl: "",
            isCoOwner: false,
            cownerDetails: {
              name: "",
              pan_number: "",
              pincode: "",
              address: "",
              state: "",
              pancardUrl: ""
            }
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    deleteHouse(index) {
      try {
        this.Exemption10.HRA.planned.details.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    setMetro(value, element){
      // if(value == 'non_metro'){
      //   element.metro = false;
      // }else{
      //   element.metro = true;
      // }
            element.metro = value !== 'non_metro';

    },

    addMoreDate() {
      try {
        this.Exemption10.HRA.planned.details.push({
          to: "",
          from: "",
          metro: "",
          value: 0,
          ownerDetails: {
            name: "",
            state: "",
            toDate: "",
            address: "",
            pinCode: null,
            fileName: "",
            fromDate: "",
            metro: "",
            panNumber: "",
            pancardUrl: ""
          },
          cownerDetails: {
            name: "",
            state: "",
            address: "",
            pincode: null,
            fileName: "",
            panNumber: "",
            pancardUrl: ""
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    deleteDate(houseIndex, dateIndex) {
      try {
        this.Exemption10.HRA[houseIndex].rentList.splice(dateIndex, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async uploadPanCard(docFile, index, type) {
      try {
        if (docFile) {
          if (docFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              if (type == "owner") {
                this.Exemption10.HRA[index].ownerDetails.pancardUrl =
                  res.data.location;
                this.Exemption10.HRA[index].ownerDetails.fileName =
                  docFile.name;
              } else {
                this.Exemption10.HRA[
                  index
                ].ownerDetails.cownerDetails.pancardUrl = res.data.location;
                this.Exemption10.HRA[
                  index
                ].ownerDetails.cownerDetails.fileName = docFile.name;
              }
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error.response.data.message;
      }
    },

    async getProfileData(){
      try {
        let obj = {
          'employee_id': this.$route.query.employee_id
        };
        let response = await this.act_getProfileData(obj);
        // console.log(response);
        this.employeeData = response.data.payload[0];
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' }
        this.employeeData.dob = new Intl.DateTimeFormat('en-IN', options).format((new Date(this.employeeData.dob))).split('/').join('-');
        this.date_of_joining = new Intl.DateTimeFormat('en-IN', options).format((new Date(this.employeeData.date_of_joining))).split('/').join('-')
        // console.log(new Date(this.date_of_joining));
        // console.log(this.employeeData.date_of_joining = new Intl.DateTimeFormat('en-IN', options).format((new Date(this.employeeData.date_of_joining))).split('/').join('-'))
        // this.postLock();
      } catch (error) {
        
      }
    },

    async uploadRentAggr(docFile, index, idx) {
      try {
        if (docFile) {
          if (docFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              if (index == idx) {
                this.Exemption10.HRA[index].rentList[index].agreementDoc =
                  res.data.location;
                this.Exemption10.HRA[index].rentList[index].fileName =
                  docFile.name;
              } else {
                this.Exemption10.HRA[
                  index
                ].rentList[index].agreementDoc = res.data.location;
                this.Exemption10.HRA[
                  index
                ].rentList[index].fileName = docFile.name;
              }
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error.response.data.message;
      }
    },
    async submitData(){
      let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        if(this.role == "EMPLOYEE") {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/mysalary/itDeclaration`,
          });
          this.$emit("section10update",this.Exemption10);
        } else {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxdeclarationplan`,
          });
          this.$emit("section10update",this.Exemption10);
        }
    },
    
    // Add here code for cancel button to hide popup By Bhushan 
    goBack() {
      this.$emit('back');
    }
  },
};
</script>

<style lang="scss" scoped>

// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }

.small-text {
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 8px;
  margin-right: 32px;
  color: #444444;
  display: flex;
}

.text-right-side {
  float: right;
}

.title-income {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
}

.title-income-normal-left {
  font-size: 1.0rem;
  color: #444444;
}

.title-income-normal-right {
  font-size: 1.0rem;
  color: #444444;
  text-align: right;
}

.title-income-left {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
}

.title-income-right {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
  text-align: right;
}

.section-table {
  padding: 24px 0px;
}

.datatable-outer-container {
  width: 100%;
}
        
.datatable-outer-container table.datatable {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
            font-family: Montserrat;
            margin-bottom: 4px;
}
        
        .datatable-outer-container table.datatable .header-row {
            background-color: white;
            height: 54px;
        }
        
        .datatable-outer-container table.datatable .header-row th {
            background-color: #f0f1f5;
            border-bottom: 1px solid #34c0be;
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .header-row th .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .inactiveCols {
            opacity: 0.03;
            background-color: #a2a1a1;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader {
            background-color: #ffffff;
            -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
            box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th {
            padding: 0 8px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span {
            border-right: 1px solid #ececec;
            padding: 0px 18px 0px 15px;
            display: inline-block;
            vertical-align: middle;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
            padding: 10px 10px 7px 10px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
            text-align: right;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
            position: absolute;
            right: 10px;
            top: 2px;
        }
        
        .datatable-outer-container table.datatable .record-row {
            height: 60px;
            border-bottom: none;
        }
        
        .datatable-outer-container table.datatable .record-row:nth-child(odd) {
            background-color: #fff;
        }
        
        .datatable-outer-container table.datatable .record-row.selectedRecord {
            background-color: #E9F9F8;
            opacity: 0.9;
        }
        
        .datatable-outer-container table.datatable .record-row td {
            padding: 6px 8px;
            color: #646464;
            font-weight: 500;
        }
        
        .datatable-outer-container table.datatable .record-row td .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .record-row .actions {
            width: 10%;
            padding: 10px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item {
            padding: 6px 20px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item p {
            width: 100%;
            margin-bottom: 0px;
        }
        
        .datatable-outer-container table.datatable .record-row .action-img {
            display: inline-block;
            cursor: pointer;
            opacity: 0;
        }
        
        .datatable-outer-container table.datatable .record-row:hover .action-img {
            opacity: 1;
        }

.add-self-occupied-property {
  width: 379px;
  height: 120px;
  padding: 24px 16px 24px 16px;
  border-radius: 4px;
  border: 2px solid #dddddd;
  background-color: #ffffff;
  cursor: pointer;  
  margin: 30px 0px;
}

.center-block-add-new {
  padding: 16px 0;
  text-align: center;
}

.block-add-new-icon {
  transform: translate(0px, 5px);
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

.inputbox{
   width: 149px;
  height: 35px;
  // width: 30%;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}

.block-1 {
  width: 400px;
  margin: 10px 0;
  display: inline-block;
  font-weight: 500;
  font-size: 1.2rem;
}

.block-2 {
  display: inline-block;
  width: 50%;
  margin: 10px 0;
}

.title-joint-property {
  margin: 15px 0;
  font-weight: 600;
  font-size: 1.2rem;
}

.inputbox-large{
  height: 35px;
  width: 30%;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}
</style>
